/* eslint-disable no-console */
import $ from 'jquery';
import 'owl.carousel';

const carousel = (element, config = {}) => {
	$(element).owlCarousel(config);
};

carousel.destroy = element => {
	$(element).owlCarousel('destroy');
};

const initCarouselCustomSettings = () => {
	const allCarousels = document.querySelectorAll(
		'[data-component=owl-carousel]',
	);

	allCarousels.forEach(currentCarousel => {
		if (currentCarousel.dataset.customSettings) {
			try {
				const carouselSettings = JSON.parse(
					currentCarousel.dataset.customSettings,
				);

				carousel(currentCarousel, carouselSettings);
			} catch (error) {
				console.warn('Carousel error:', error);
			}
		}
	});
};

export { carousel as default, initCarouselCustomSettings };
